<template>
	<div>
		<template v-if="$route.params.withdraw == 'pay'">
			<h4>Paykasa Para Yatır</h4>
			<div class="paykasa_wrapper" :style="{ backgroundImage: 'url(static/assets/img/paykasa_bg.png)' }">
				<paykasaForm />
			</div>
		</template>
		<template v-if="$route.params.withdraw == 'withdraw'">
			<paykasaWithdraw />
		</template>
	</div>
</template>

<script>
	import paykasaForm from '@/components/payments/form/paykasa'
    import paykasaWithdraw from '@/components/payments/form/paykasaWithdraw'
    export default {
        name: "paykasa",
        components: {paykasaForm,paykasaWithdraw}
    }
</script>

<style scoped>
	.paykasa_wrapper{
		background-repeat: no-repeat;
		background-size: auto;
		height: 320px;
		width: 510px;
		margin: auto;
		padding: 90px;
	}
</style>


// WEBPACK FOOTER //
// src/components/payments/gateways/paykasa.vue